<form class="card mt-2" *ngIf="canEdit">
  <div class="card-body">
      <button *ngIf="canEdit" class="btn btn-primary float-right pointer" routerLink="/form-builder/form">Create new Form</button>
      <button *ngIf="canEdit" class="btn btn-link float-right pointer" routerLink="/form-builder/forms-assignment">Forms Assignment</button>
      <h2 class="mb-3">Forms</h2>
      <h5>Filter <button class="btn btn-link" (click)="toggleHideFilter()">{{showHideString}}</button></h5>
      <div class="row mb-3" [hidden]="hideFilter">
        <div class="col-6">
          <div class="row  mb-2">
            <div class="col-4 d-flex align-items-center">
              <b>Form Name:</b>
            </div>
            <div class="col-8">
              <i *ngIf="!formNames" class="material-icons rotate text-muted">loop</i>
              <p-multiSelect #formNameMultiSelect (onFocus)="openMultiSelect(formNameMultiSelect)" autofocusFilter="true" class="w-100" styleClass="w-100 d-flex " inputStyleClass="form-control"
                             [options]="formNames" [defaultLabel]="'Select ...'"
                             [(ngModel)]="formNameFilter" (ngModelChange)="changedFilters()" [ngModelOptions]="{standalone: true}"></p-multiSelect>
            </div>
          </div>
          <div class="row mb-2" >
            <div class="col-4 d-flex align-items-center">
              <h6>Form Type:</h6>
            </div>
            <div class="col-8 ">
              <!-- <p-select styleClass="app-select  w-100" [options]="formTypes" placeholder="Select ..."  [(ngModel)]="formTypeFilter" (ngModelChange)="changedFilters()" [ngModelOptions]="{standalone: true}"></p-select> -->
              <p-multiSelect #formTypeMultiSelect (onFocus)="openMultiSelect(formTypeMultiSelect)" autofocusFilter="true" class="w-100" styleClass="w-100 d-flex " inputStyleClass="form-control"
                             [options]="formTypes" [defaultLabel]="'Select ...'"
                             [(ngModel)]="formTypeFilter" (ngModelChange)="changedFilters()" [ngModelOptions]="{standalone: true}"></p-multiSelect>
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-4 d-flex align-items-center">
              <h6>Active:</h6>
            </div>
            <div class="col-8 ">
              <p-selectButton styleClass="w-100" [options]="yesNoAllOptions" [(ngModel)]="formActiveFilter" (ngModelChange)="changedFilters()" [ngModelOptions]="{standalone: true}"></p-selectButton>
            </div>
          </div>
        <button class="btn btn-secondary float-left pointer" (click)="clearFilter()">Clear Filter</button>
        </div>
      </div>

    <i *ngIf="!formsList" class="material-icons rotate text-muted">loop</i>
    <p-table #formTable [value]="formsList?.result" [responsive]="true"
    [paginator]="true" [rows]="20"
    [totalRecords]="formsList?.totalRecords" [lazy]="true"
    (onLazyLoad)="loadPage($event)">
        <ng-template pTemplate="header">
            <tr>
                <th width="145px"></th>
                <th [pSortableColumn]="'Name'" >Form Name
                  <p-sortIcon [field]="'Name'"></p-sortIcon></th>
                <th [pSortableColumn]="'FormType'">Form Type
                  <p-sortIcon [field]="'FormType'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'Inactive'">Active
                  <p-sortIcon [field]="'Inactive'"></p-sortIcon>
                </th>

            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-fbForm>
            <tr >
                <td>
                  <span class="pointer mr-2" *ngIf="canEdit"   (click)="editForm(fbForm)"><i title="Edit Form" class="fas fa-edit"></i></span>
                  <span class="pointer mr-2" *ngIf="canEdit && (fbForm.inactive == false || fbForm.inactive == null)" (click)="deleteForm(fbForm)"><i title="Delete Form" class="fas fa-trash"></i></span>
                  <span class="pointer mr-2" *ngIf="canEdit && fbForm.inactive == true"   (click)="restoreForm(fbForm)"><i title="Restore Form" class="fas fa-heart"></i></span>
                  <span class="pointer mr-2" *ngIf="canEdit && fbForm.formTypeID==1"   (click)="editFormRolesAssignment(fbForm)"><i title="Manage Form Role Assignment" class="fas fa-user-tag"></i></span>
                  <span class="pointer mr-2" *ngIf="canEdit"   (click)="copyForm(fbForm)"><i title="Duplicate Form" class="fas fa-copy"></i></span>
                </td>
                <td>
                    <span class="ui-column-title">Form Name</span>
                  {{fbForm.name }}
                </td>

                <td>
                  <span class="ui-column-title">Form Type</span>
                  {{fbForm.formType }}
                </td>

                <td>
                  <span class="ui-column-title">Active</span>
                  {{fbForm.inactive?'No':'Yes' }}
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="paginatorleft" let-state>
            Showing {{ state.first + 1 }} - {{ (state.first + state.rows) > state.totalRecords ? state.totalRecords : (state.first + state.rows) }} of {{ state.totalRecords }} entries
        </ng-template>
        <ng-template pTemplate="paginatorright">
              <div style="display: flex; align-items: center; gap: 0.5rem;">
                  <span style="color: #495057; font-size: 14px; white-space: nowrap;">Rows per page:</span>
                  <p-dropdown 
                      [options]="dropdownOptions()" 
                      optionLabel="label" 
                      optionValue="value"
                      [ngModel]="formTable.rows" 
                      (onChange)="formTable.rows = $event.value; formTable.reset()">
                  </p-dropdown>
              </div>
        </ng-template>
    </p-table>
  </div>
</form>

<p-confirmDialog></p-confirmDialog>
